import React, { FC } from 'react'
import './index.scss'

// interface
interface IProps extends React.HTMLAttributes<HTMLDivElement> {
}

const Loading: FC<IProps> = () => {
  return (
    <div className='loading'>
      {
        [...Array(4)].map((item, index) => {
          return (
            <div className='round' key={index}></div>
          )
        })
      }
    </div>
  )
}

export default Loading
